import { render, staticRenderFns } from "./ServiceAgreements.vue?vue&type=template&id=52002c91"
import script from "./ServiceAgreements.vue?vue&type=script&lang=js"
export * from "./ServiceAgreements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports